if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.filterVariantMedia();
        this.showActiveMedia();
      }

      filterVariantMedia() {
        const productInfo = document.querySelector('product-info[data-product-id]');
        const variant = productInfo?.getSelectedVariant?.(productInfo);
        const configuredIds = productInfo?.variantGalleryMap?.[String(variant?.id)];

        if (!Array.isArray(configuredIds) || configuredIds.length === 0) return;

        const allowed = new Set(configuredIds.map(String));
        const getMediaId = (value) => String(value || '').split('-').pop();

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          const visible = allowed.has(getMediaId(element.dataset.mediaId));
          element.hidden = !visible;
          element.setAttribute('aria-hidden', visible ? 'false' : 'true');

          // En escritorio el tema fuerza display:block para los elementos no activos
          // del modal, por lo que el atributo hidden por sí solo no es suficiente.
          element.style.setProperty('display', visible ? '' : 'none', 'important');

          if (!visible) element.classList.remove('active');
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
